/**
 * Ensures a URL has a protocol (http:// or https://)
 * If no protocol is present, prepends https://
 * @param url The URL to check
 * @returns URL with protocol
 */
export const ensureProtocol = (url: string): string => {
  if (!url.startsWith("http://") && !url.startsWith("https://")) {
    return `https://${url}`;
  }
  return url;
};
